import {
    httpPost, httpGet
} from "/config/request.js"
// 获取商品信息
export function getProdInfoApi(params) {
    return httpPost('/prod/prodInfo/getProdInfo', params)
}
// 获取商品评价
export function selectOrderProductEvaluatePageApi(params) {
    return httpPost('/order/orderProductEvaluate/selectOrderProductEvaluatePage', params)
}
// 分页查询商品
export function selectProdInfoPageApi(params) {
    return httpPost('/prod/prodInfo/selectProdInfoPage', params)
}

// 获取激活商品信息
export function getActiveProdInfo(params) {
    return httpPost('prod/prodInfo/getActiveProdInfo', params)
}

export function getActiveProdInfoApi(params) {
    return httpPost('/prod/prodInfo/getActiveProdInfo', params)
}

//查询个人装修
export function selDecorateHeaderSet(params) {
    return httpPost('/prod/decorateInfo/selDecorateHeaderSet', params)
}

// 获取商品分类信息
export function selProdClassifyInfoTwoApi(params) {
    return httpPost('/prod/prodInfo/selProdClassifyInfo/two', params)
}

// 检查用户信息
export function checkOutMembInfoApi(params) {
    return httpPost('/memb/membInfo/checkOutMembInfo', params)
}

// 获取购买数量统计
export function getBuyNumCountApi(params) {
    return httpPost('/order/orderInfo/getBuyNumCount', params)
}

// 检查库存数量
export function checkStockNumApi(params) {
    return httpPost('/order/orderInfo/checkStockNum', params)
}

// 获取会员信息
export function getMembInfoByIdApi(params) {
    return httpPost('/memb/membInfo/getMembInfoById', params)
}

// 获取系统设置信息
export function getBaseSystemSetInfoByPlatIdApi(params) {
    return httpPost('/base/baseRuleSet/getBaseSystemSetInfoByPlatId', params)
}
// 查询商品是否禁用
export function selectProdInfoBysingleProdIdsApi(params) {
    return httpPost('/prod/prodInfo/selectProdInfoBysingleProdIds', params)
}
// 批量查询商品是否禁用
export function batchCheckProdIsStopSaleApi(params) {
    return httpPost('/prod/prodInfo/batchCheckProdIsStopSale', params)
}

// 首页获取商品信息
export function selectDecorateInfoBoByShopId(params) {
    return httpPost('/prod/decorateInfo/selectDecorateInfoBoByShopId', params)
}